import { InjectionToken } from '@angular/core';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';
import { Observable } from 'rxjs';

export interface BdShareRequest {
  shareableType: ShareableType;
  shareableId: string;
  shareableName: string;
  shareableTypeLabel?: string;
  modifiedDate?: string;
}

export interface BdShareResult {
  granted: boolean;
}

/**
 * Opens the share/grant dialog for a single shareable and emits exactly once:
 *  - a `{ granted: boolean }` result when the dialog completed (success or with errors),
 *  - `null` when the dialog was cancelled or closed without granting.
 *
 * The implementation lives in `@bindoc-projects/resource-lib/registration` so apps that don't need the
 * grant flow don't pull the stepper/preview machinery into their eager bundle.
 * Apps that need it should provide the token via `provideShareDialog()`
 * (exported from `@bindoc-projects/resource-lib/registration`).
 */
export type BdShareOpener = (
  request: BdShareRequest,
) => Observable<BdShareResult | null>;

export const BD_SHARE_OPENER = new InjectionToken<BdShareOpener>(
  'BD_SHARE_OPENER',
);
